import type { MailboxInfo } from 'owa-client-types';
import { getIsFocusedInboxEnabled } from 'owa-session-store';
import { saveFocusedInboxOption } from 'owa-focused-option';

export async function onToggleFocusedInbox(mailboxInfo: MailboxInfo): Promise<void> {
    const isFocusedInboxEnabled = !!getIsFocusedInboxEnabled(mailboxInfo);

    await saveFocusedInboxOption(mailboxInfo, !isFocusedInboxEnabled);
}
